export default __webpack_public_path__ + "static/media/emergingMarketBg@2x.683f486a.png";